import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, ArrowDown, Crown } from 'lucide-react';
const promoImages = [{
  image: 'https://cdn.magicpatterns.com/uploads/3sFWFf9AzQM3tcnhAJGoxk/slide_1.png',
  alt: 'Oferta de lanzamiento: Pack completo'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/qAATN5yVSEPR47rdfYcHp1/slide_2.png',
  alt: '¿Te pasa esto con tu dinero?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gF9vAhFXCy3Y1aVafXQgD2/slide_3.png',
  alt: '¿Cómo podrías estar en 30 días?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/xB9U5e2jm3h9QqtuAUDjyJ/slide_4.png',
  alt: '¿Te pasa esto con tu dinero? - Pain points'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gnHVbEU8hVYnSfTUdh35wW/promocion_finanzas_faciles.png',
  alt: 'Pack Finanzas Fáciles para Mujeres'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jQnRN7vVQ7EZtqQ3b8MCvc/slide_6.png',
  alt: 'Oferta especial'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/bfDdsshXMWcQ1TwMsJcPkw/slide7.png',
  alt: 'Oferta de lanzamiento con pack visual'
}];
export function PromoCampaign() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // Auto-cycle through promotional images
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex(prev => (prev + 1) % promoImages.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(timer);
  }, []);
  return <section className="py-20 md:py-32 bg-gradient-to-b from-[#f5f1e8] to-white relative overflow-hidden" data-id="element-652">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4a574] opacity-5 rounded-full blur-3xl" data-id="element-653"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1e3a5f] opacity-5 rounded-full blur-3xl" data-id="element-654"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-655">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-656">
          {/* Left side - Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-657">
            {/* Opening hook */}
            <div className="space-y-6" data-id="element-658">
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="text-2xl md:text-3xl font-serif text-[#1e3a5f] leading-relaxed italic" data-id="element-659">
                Empiezas leyendo una cosa… y, sin darte cuenta, ya estás tomando
                decisiones que tu{' '}
                <span className="text-[#d4a574] font-bold not-italic" data-id="element-660">
                  "yo del futuro"
                </span>{' '}
                te va a agradecer.
              </motion.p>

              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} className="text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-661">
                Es raro:{' '}
                <span className="text-[#1e3a5f] font-semibold" data-id="element-662">
                  nadie te enseñó a manejar el dinero
                </span>
                … y aun así, algo dentro de ti sabe que estás lista para
                dominarlo.
              </motion.p>
            </div>

            {/* Divider */}
            <motion.div initial={{
            opacity: 0,
            scaleX: 0
          }} whileInView={{
            opacity: 1,
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="h-px bg-gradient-to-r from-transparent via-[#d4a574] to-transparent" data-id="element-663" />

            {/* Product description */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.8
          }} className="space-y-6" data-id="element-664">
              <div className="flex items-start gap-3" data-id="element-665">
                <Sparkles className="w-6 h-6 text-[#d4a574] flex-shrink-0 mt-1" data-id="element-666" />
                <div data-id="element-667">
                  <div className="flex items-center gap-3 mb-3" data-id="element-668">
                    <h3 className="text-2xl font-serif font-bold text-[#1e3a5f]" data-id="element-669">
                      Finanzas Fáciles para Mujeres
                    </h3>
                    <div className="flex items-center gap-1 bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-670">
                      <Crown className="w-3 h-3" data-id="element-671" />
                      <span data-id="element-672">Edición Premium</span>
                    </div>
                  </div>
                  <p className="text-lg text-gray-600 leading-relaxed mb-4" data-id="element-673">
                    Tu kit completo:
                  </p>
                  <ul className="space-y-2 text-gray-700" data-id="element-674">
                    <li className="flex items-start gap-2" data-id="element-675">
                      <span className="text-[#d4a574] font-bold" data-id="element-676">•</span>
                      <span data-id="element-677">Ebook principal</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-678">
                      <span className="text-[#d4a574] font-bold" data-id="element-679">•</span>
                      <span data-id="element-680">Diario de Dinero en Acción</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-681">
                      <span className="text-[#d4a574] font-bold" data-id="element-682">•</span>
                      <span data-id="element-683">Plan para Salir de Deudas</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-684">
                      <span className="text-[#d4a574] font-bold" data-id="element-685">•</span>
                      <span data-id="element-686">Ahorro con Propósito</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-687">
                      <span className="text-[#d4a574] font-bold" data-id="element-688">•</span>
                      <span data-id="element-689">Dinero en Pareja y Familia</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-690">
                      <span className="text-[#d4a574] font-bold" data-id="element-691">•</span>
                      <span data-id="element-692">Ingresos Extra</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-693">
                      <span className="text-[#d4a574] font-bold" data-id="element-694">•</span>
                      <span data-id="element-695">Mentalidad y Afirmaciones de Abundancia</span>
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>

            {/* Transformation promise */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 1.0
          }} className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-[#d4a574]/20 shadow-lg" data-id="element-696">
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-697">
                Todo diseñado para que,{' '}
                <span className="text-[#1e3a5f] font-semibold" data-id="element-698">
                  paso a paso
                </span>
                , transformes el{' '}
                <span className="line-through text-gray-400" data-id="element-699">
                  caos financiero
                </span>{' '}
                en{' '}
                <span className="text-[#d4a574] font-bold" data-id="element-700">
                  claridad, control y tranquilidad real
                </span>{' '}
                con el dinero.
              </p>
            </motion.div>
          </motion.div>

          {/* Right side - Auto-cycling promotional images */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative" data-id="element-701">
            <div className="relative aspect-square max-w-lg mx-auto" data-id="element-702">
              <AnimatePresence mode="wait" data-id="element-703">
                <motion.div key={currentImageIndex} initial={{
                opacity: 0,
                scale: 0.95
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.95
              }} transition={{
                duration: 0.6
              }} className="absolute inset-0" data-id="element-704">
                  <img src={promoImages[currentImageIndex].image} alt={promoImages[currentImageIndex].alt} className="w-full h-full object-contain rounded-2xl shadow-2xl" data-id="element-705" />
                </motion.div>
              </AnimatePresence>

              {/* Progress indicators */}
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-706">
                {promoImages.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`transition-all duration-300 rounded-full ${index === currentImageIndex ? 'bg-[#d4a574] w-8 h-2' : 'bg-gray-300 hover:bg-gray-400 w-2 h-2'}`} aria-label={`Ver imagen ${index + 1}`} data-id="element-707" />)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}